let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("9zLwF"), load("d9B3Y")]).then(() => parcelRequire('fcjmy'));